/**
 * TODO 
 * There's a missing export from the basecoat library. There's an open ticket for 
 * this and it should be resolved in the next release. Once done, we need
 * to remove the all import and replace this with the base import. We can then
 */
import 'basecoat-css/basecoat';
import 'basecoat-css/sidebar';
import 'basecoat-css/select'
import 'basecoat-css/dropdown-menu'
import 'basecoat-css/popover'
import 'basecoat-css/toast';
import 'basecoat-css/tabs';

// TODOUI when global scope disappears remove this
//import * as stdjs from 'js/stdjs';

stdjs.form_element.initJQueryPlugin();